/*!
 * jQuery-ajaxTransport-XDomainRequest - v1.0.4 - 2015-03-05
 * https://github.com/MoonScript/jQuery-ajaxTransport-XDomainRequest
 * Copyright (c) 2015 Jason Moon (@JSONMOON)
 * Licensed MIT (/blob/master/LICENSE.txt)
 */
 
(function(a){if(typeof define==='function'&&define.amd){define(['jquery'],a)}else if(typeof exports==='object'){module.exports=a(require('jquery'))}else{a(jQuery)}}(function($){if($.support.cors||!$.ajaxTransport||!window.XDomainRequest){return $}var n=/^(https?:)?\/\//i;var o=/^get|post$/i;var p=new RegExp('^(\/\/|'+location.protocol+')','i');$.ajaxTransport('* text html xml json',function(j,k,l){if(!j.crossDomain||!j.async||!o.test(j.type)||!n.test(j.url)||!p.test(j.url)){return}var m=null;return{send:function(f,g){var h='';var i=(k.dataType||'').toLowerCase();m=new XDomainRequest();if(/^\d+$/.test(k.timeout)){m.timeout=k.timeout}m.ontimeout=function(){g(500,'timeout')};m.onload=function(){var a='Content-Length: '+m.responseText.length+'\r\nContent-Type: '+m.contentType;var b={code:200,message:'success'};var c={text:m.responseText};try{if(i==='html'||/text\/html/i.test(m.contentType)){c.html=m.responseText}else if(i==='json'||(i!=='text'&&/\/json/i.test(m.contentType))){try{c.json=$.parseJSON(m.responseText)}catch(e){b.code=500;b.message='parseerror'}}else if(i==='xml'||(i!=='text'&&/\/xml/i.test(m.contentType))){var d=new ActiveXObject('Microsoft.XMLDOM');d.async=false;try{d.loadXML(m.responseText)}catch(e){d=undefined}if(!d||!d.documentElement||d.getElementsByTagName('parsererror').length){b.code=500;b.message='parseerror';throw'Invalid XML: '+m.responseText;}c.xml=d}}catch(parseMessage){throw parseMessage;}finally{g(b.code,b.message,c,a)}};m.onprogress=function(){};m.onerror=function(){g(500,'error',{text:m.responseText})};if(k.data){h=($.type(k.data)==='string')?k.data:$.param(k.data)}m.open(j.type,j.url);m.send(h)},abort:function(){if(m){m.abort()}}}});return $}));

$(function() {
    var key = $('meta[name=api_key]');
    $.ajaxSetup({headers: {"api-key": key ? key.attr('content') : ''}});

    var api_url = $('meta[name=api_url]').attr('content');
    var event_id = $('meta[name=event_id]').attr('content');
    var currentPage = 1;

    var container = $('#directory-container');
    var loadingHtml = '<p class="alert text-center"><i class="fa fa-spin fa-refresh fa-lg"></i></p>';

    var loadDirectory = function(page, search) {
        container.html(loadingHtml);
        page = page ? page : 1;
        search = search ? search : '';

        $.ajax({//with_bio=true
            url: api_url+'/events/'+event_id+'/delegates?with_bio=true&per_page=18&page='+page+'&search='+search,
            type: 'GET',
            dataType: 'json',
            success: function(response){
                var delegates = response.delegates;
                var directoryHtml = '';
                if(delegates.length) {
                    for(var i = 0; i < delegates.length; i++) {
                        directoryHtml +=
                        '<div class="col-sm-4">' +
                            '<div class="panel panel-default panel-profile">' +
                                '<div class="panel-heading text-center">';
                                    if(delegates[i].photo) {
                                        directoryHtml +=
                                        '<div class="photo-container">' +
                                            '<img src="'+delegates[i].photo+'" class="img-circle" style="max-width: 100%;" />' +
                                        '</div>';
                                    } else {
                                        directoryHtml += '<span class="badge">'+delegates[i].firstname.charAt(0)+delegates[i].surname.charAt(0)+'</span>';
                                    }
                                directoryHtml +=
                                '</div>' + 
                                '<div class="panel-body text-center">' +
                                    '<h3>'+delegates[i].firstname+' '+delegates[i].surname+'</h3>' +
                                    '<h4>';
                                        if(delegates[i].position) {
                                            directoryHtml += '<strong>'+delegates[i].position+'</strong>';
                                            if(delegates[i].department) {
                                                directoryHtml += ', ';
                                            }
                                        }
                                        if(delegates[i].department) {
                                            directoryHtml += delegates[i].department;
                                            if(delegates[i].level) {
                                                directoryHtml += ', ';
                                            }
                                        }
                                        if(delegates[i].level) {
                                            directoryHtml += delegates[i].level;
                                        }
                                    directoryHtml += '</h4>';
                                    directoryHtml += '<p class="lead">';
                                        for(const key in delegates[i].field_responses) {
                                            if(delegates[i].field_responses[key] != 'null') {
                                                directoryHtml += '<strong>' + key + '</strong>: ' + delegates[i].field_responses[key] + '<br>';
                                            }
                                        }
                                    directoryHtml += '</p>';    
                                    if(delegates[i].linkedin) {
                                        directoryHtml += '<a href="http://www.linkedin.com/in/'+delegates[i].linkedin+'" class="btn btn-sm btn-default btn-linkedin"><img src="/templates/basic/images/linkedin.png" height="14"></a>';
                                    }
                                    directoryHtml += '<button type="button" data-toggle="modal" data-target="#biography-modal-'+delegates[i].id+'" class="btn btn-sm btn-default"><i class="fa fa-user"></i> View full biography</button>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

                        directoryHtml += 
                        '<div id="biography-modal-'+delegates[i].id+'" class="modal fade" tabindex="-1">' +
                            '<div class="modal-dialog">' +
                                '<div class="modal-content">' +
                                    '<div class="modal-header">' +
                                        '<button type="button" class="close" data-dismiss="modal">' +
                                            '<span aria-hidden="true">&times;</span>' +
                                        '</button>' +
                                        '<h4 class="modal-title">'+delegates[i].firstname+' '+delegates[i].surname+'</h4>' +
                                    '</div>' +
                                    '<div class="modal-body">' +
                                        '<p>'+delegates[i].biography_formatted+'</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';
                    }
                    $('.directory-nav').removeClass('hide');

                    if(response.total_delegates == 1) {
                        $('.result-count').text('Showing 1 delegate');
                    } else {
                        var start = ((response.pagination.current_page-1)*18)+1;
                        var end = ((response.pagination.current_page-1)*18)+18 < response.total_delegates ? ((response.pagination.current_page-1)*18)+18 : response.total_delegates;
                        $('.result-count').text('Showing '+start+'-'+end+' of '+response.total_delegates+' delegates');
                    }

                    $('.current-page').text(response.pagination.current_page);
                    if(response.pagination.prev_page_url) {
                        $('.prev-page').prop('disabled', false);
                    } else {
                        $('.prev-page').prop('disabled', true);
                    }
                    if(response.pagination.next_page_url) {
                        $('.next-page').prop('disabled', false);
                    } else {
                        $('.next-page').prop('disabled', true);
                    }
                } else {
                    directoryHtml = '<p class="alert text-center">We couldn&rsquo;t find any delegates that match your search.</p>';
                    $('.directory-nav').addClass('hide');
                    currentPage = 1;
                }       
                container.html(directoryHtml);
            },
            error: function(data, i, s) {
                //alert(i);
            }
        });
    }

    loadDirectory();

    $('#search-directory').on('submit', function (e) {
        e.preventDefault();
        currentPage = 1;
        $('input[name=search]').blur();
        $('#clear-search').removeClass('hide');
        loadDirectory(currentPage, $('input[name=search]').val());
    });

    $('#clear-search').on('click', function () {
        currentPage = 1;
        $('#clear-search').addClass('hide');
        $('input[name=search]').val('');
        loadDirectory(currentPage);
    });

    $('.prev-page').on('click', function() {
        currentPage--;
        loadDirectory(currentPage, $('input[name=search]').val());
    });

    $('.next-page').on('click', function() {
        currentPage++;
        loadDirectory(currentPage, $('input[name=search]').val());
    });
});